// src/index.js
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import AppShell from "./services/AppShell";
import reportWebVitals from "./reportWebVitals";

// ==== Parche de emergencia: bloquear ui-avatars.com para evitar bucles ====
(function () {
  const BAD = "ui-avatars.com";

  // Bloquea <img src="...ui-avatars.com...">
  const desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
  if (desc && desc.set) {
    const origSet = desc.set;
    Object.defineProperty(HTMLImageElement.prototype, "src", {
      set(v) {
        try {
          if (typeof v === "string" && v.includes(BAD)) {
            console.warn("[avatar] bloqueado:", v);
            return;
          }
        } catch {}
        return origSet.call(this, v);
      },
    });
  }

  // Bloquea fetch("https://ui-avatars.com/...")
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      if (url.includes(BAD)) {
        console.warn("[avatar] fetch bloqueado:", url);
        return Promise.resolve(new Response("", { status: 204 }));
      }
    } catch {}
    return origFetch(input, init);
  };
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>
);

reportWebVitals();
